module.exports = __webpack_public_path__ + "img/UNI.db62f270.svg";